import { showWarning } from "../toast/toastUtil";

/**
 * Base64 문자열을 Blob으로 변환하는 함수
 * @param base64 - Base64 인코딩된 문자열
 * @param mimeType - MIME 타입 (예: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
 * @returns Blob 객체
 * @example
 * const blob = base64ToBlob(base64String, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
 * downloadExcel(blob, '파일명.xlsx');
 */
export const base64ToBlob = (base64: string, mimeType: string): Blob => {
    const binaryString = atob(base64);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }
    return new Blob([byteArray], { type: mimeType });
};

/**
 * Base64 문자열을 엑셀 파일로 다운로드하는 함수
 * @param options - responseData: Base64 문자열, fileName: 저장할 파일명
 * @deprecated base64ToBlob와 downloadExcel을 직접 사용하는 것을 권장합니다.
 */
export const downloadSettingExcel = (
    options: {
        responseData: string;
        fileName: string;
    }
) => {
    const { responseData, fileName } = options;

    try{
        const blob = base64ToBlob(
            responseData, 
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
        downloadExcel(blob, fileName);
    }catch(error){
        showWarning('엑셀 다운로드 중 오류가 발생했습니다.');
    }
}


export const downloadExcel = (blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);
    // 다운로드 링크 생성
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // 다운로드 파일 이름 설정
    a.click();
    // URL 및 임시 링크 정리
    window.URL.revokeObjectURL(url);
    a.remove();
}